import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEdit = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1000 1000",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M61 576L589 49C627 11 672 10 711 49L815 153C854 192 853 237 815 275L287 802H61ZM559 178L513 224L640 351L686 305ZM253 737L780 211L653 84L126 610V783L80 737ZM20 912V980H980V912Z" })
});
export default SvgEdit;
